import React, { useState, useEffect } from 'react';
import { Typography, MobileStepper, Button } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useTranslation } from 'react-i18next';
import { WizardForApproveStep } from '../types';

export default function(props: {
  text: string;
  steps: WizardForApproveStep[];
  activeStep: number;
}) {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    setActiveStep(props.activeStep);
  }, [props.activeStep]);

  function handleNext() {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  }

  function handleBack() {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  }

  if (!props.steps[activeStep]) {
    return null;
  }

  return (
    <>
      <Typography variant="body1">{props.text}</Typography>
      {props.steps[activeStep].content}
      <MobileStepper
        variant="dots"
        steps={props.steps.length}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="medium"
            onClick={handleNext}
            disabled={props.steps[activeStep].isNextDisabled()}
            data-next
          >
            {t('next')}
            <KeyboardArrowRight />
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            <KeyboardArrowLeft />
            {t('back')}
          </Button>
        }
      />
    </>
  );
}
